<template>
  <div class="member-modal-overlay" v-if="visible">
    <div class="member-modal">
      <div class="member-modal__body member-modal__body--contact">
        <h3 class="member-modal__title">Contact Info</h3>
        <span class="member-modal__close-icon" @click="$emit('close')">
          <i class="fa fa-times"></i>
        </span>
        <ul class="member-contact-list" v-if="details">
          <li class="member-contact-list__item">
            <span class="member-contact-list__label">Email : </span>
            <span class="member-contact-list__value">{{ details.email }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactInfoModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    details: {
      type: Object,
      default: () => null
    }
  }
};
</script>

<style lang="scss" scoped>
.member-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 1000;
  display: flex;
  align-items: center;
}

.member-modal {
  width: 100%;

  &__body--contact {
    background: #000;
    width: 520px;
    max-width: 90vw;
    margin: 0 auto;
    border-radius: 5px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    color: #ffffff;
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    position: relative;
    padding: 15px 20px;
  }

  &__title {
    font-size: 20px;
    letter-spacing: 0;
    margin-bottom: 0;
  }

  &__close-icon {
    position: absolute;
    top: 15px;
    right: 15px;
    .fa {
      font-size: 20px;
      color: red;
      cursor: pointer;
    }
  }
}

.member-contact-list {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: 15px;
  padding: 0;
  list-style: none;

  &__item {
    font-size: 20px;
    margin-top: 15px;
  }

  &__label { color: #fffcc4; }
  &__value { color: #ffffff; }
}
</style>